import { consumer, core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import consumerProtos from 'utils/consumerProto';
import protos from 'utils/protos';

const { NavSuggestRequest, ShopNavSuggestRequest } = consumerProtos;
const { BusinessSearchRequest } = protos;

export function search(requestJson: core.BusinessSearchRequest, cache = false): ApiAction {
  const request = BusinessSearchRequest.fromObject(requestJson);
  return {
    TockApi: {
      postProto: '/business/marketing/search',
      request,
      type: AppConstants.DISCOVER_SEARCH,
      onError: {
        7003: '',
        defaultToOriginal: true,
      },
      cacheOptions: cache
        ? {
            enableCache: true,
            maxAge: 60 * 1000,
          }
        : undefined,
    },
  };
}

export function autocompleteBusinessSuggestions(
  searchText: string,
  location?: { lat: number; lng: number }
): ApiAction<consumer.NavSuggestResponse> {
  let requestObj = { searchText, businessOptions: { numResults: 20 } };
  if (location) {
    requestObj = {
      ...requestObj,
      ...location,
    };
  }
  const request = NavSuggestRequest.fromObject(requestObj);
  return {
    TockApi: {
      postProto: '/consumer/suggest/nav',
      request,
      type: AppConstants.DISCOVER_AUTOCOMPLETE_NAV_SUGGESTIONS,
      onError: {
        7003: '',
        defaultToOriginal: true,
      },
    },
  };
}

export function autocompleteShopSuggestions(
  searchText: string
): ApiAction<consumer.ShopNavSuggestResponse> {
  const requestObj: consumer.ShopNavSuggestRequest = { searchText };

  const request = ShopNavSuggestRequest.fromObject(requestObj);

  return {
    TockApi: {
      postProto: '/consumer/shop/suggest/nav',
      request,
      type: AppConstants.NULL,
      onError: {
        7003: '',
        defaultToOriginal: true,
      },
    },
  };
}
